import { useMutation, UseMutationOptions } from "react-query";
import { acceptTou } from "../api/tou";

export const useAcceptTou = (options?: UseMutationOptions) => useMutation(acceptTou, options);
